import { render } from "./choseProduct.vue?vue&type=template&id=7f9a994e&scoped=true"
import script from "./choseProduct.vue?vue&type=script&lang=js"
export * from "./choseProduct.vue?vue&type=script&lang=js"

import "./choseProduct.vue?vue&type=style&index=0&id=7f9a994e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9a994e"]])

export default __exports__